import { notify } from "./core";

window.toastr = window.toastr || notify;

export default window.toastr;
